// src/components/ui/WelcomeBanner.tsx
// SPDX-License-Identifier: MIT

import React, { useEffect, useState } from 'react';
import styled, { keyframes, ThemeProvider } from 'styled-components';
import { integralAnalyticsTheme } from '../../theme';
import { APP_TITLE } from '../../constants/default-settings';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

const BannerWrapper = styled.div`
  position: fixed;
  top: 20px;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  z-index: 10001;
  pointer-events: none;
`;

const BannerContainer = styled.div<{ show: boolean }>`
  background-color: ${props => props.theme.sidePanelBg};
  color: ${props => props.theme.textColor};
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  font-size: 1rem;
  animation: ${props => (props.show ? fadeIn : fadeOut)} 0.5s ease-in-out forwards;
  border: 1px solid ${props => props.theme.inputBorderColor};
  pointer-events: auto;
`;

const Logo = styled.img`
  height: 24px;
  margin-right: 12px;
`;

// Dedicated WelcomeBanner, not for general use

const WelcomeBanner: React.FC = () => {
  const [show, setShow] = useState(true);
  const [shouldRender, setShouldRender] = useState(true);

  useEffect(() => {
    // Start fade-out animation
    const fadeTimer = setTimeout(() => {
      setShow(false);
    }, 4500);

    // Remove component completely after animation finishes
    const removeTimer = setTimeout(() => {
      setShouldRender(false);
    }, 5000); // 4500ms + 500ms animation duration

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!shouldRender) {
    return null;
  }

  return (
    <ThemeProvider theme={integralAnalyticsTheme}>
      <BannerWrapper>
        <BannerContainer show={show}>
          <Logo src='/assets/integral-analytics-logo.png' alt='Integral Analytics Logo' />
          <span>{APP_TITLE} - Geospatial Data Visualization Platform | Powered by kepler.gl</span>
        </BannerContainer>
      </BannerWrapper>
    </ThemeProvider>
  );
};

export default WelcomeBanner;
